module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/axios/index.js
// module id = 92
// module chunks = 0